import PropTypes from 'prop-types'
import {Box, Flex} from '@chakra-ui/react'

const MCoinsCell = ({getValue}) => {
  const transaction = getValue()

  if (!transaction) {
    return (
      <Box fontWeight="500" textAlign="right" width="100%" display="block">
        -
      </Box>
    )
  }

  const {amount, type} = transaction
  const isCredit = type === 'credit'
  const signColor = isCredit ? 'mld.success.700' : 'mld.alert.700'
  const sign = isCredit ? '+' : '-'

  return (
    <Flex justify="flex-end">
      <Box color={signColor} mr="xs">
        {sign}
      </Box>
      <Box>{amount.toLocaleString()}</Box>
    </Flex>
  )
}

MCoinsCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default MCoinsCell
